import React, { useEffect } from 'react';
import PropTypes from 'prop-types'
import { useHistory, withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import logo from 'assets/img/Logo.png'
import { getAlert } from 'redux/actions/authActions'
import { Theme } from 'utils/Theme'
import { withStyles } from '@material-ui/styles'
import background from 'assets/img/storeFront.png'
import Section from 'components/UI/Section'
import { Box } from '@material-ui/core';
import AuthAlert from './AuthAlert';
const styles = Theme()

const AuthLayout = ({
	auth,
	getAlert,
	classes,
	theme,
	alert,
	isAuthenticated,
	children,
}) => {
  	const history = useHistory();

	useEffect(() => {
		getAlert();
  	}, []);

  	return (
		<div
			className={'App login'}
			style={{
				backgroundImage: `url(${background})`,
				backgroundPosition: 'center center',
				backgroundSize: 'cover',
			}}
		>
			<div className="o-page o-page--center">
				<div className="o-page__card">
					<Section elevation={1}>
						<Box className=" c-card--center u-p-medium">
							<Link to="/">
								<img src={logo} className={'u-m-medium'} alt="cap logo" width={250} />
							</Link>

							{alert && alert.status === 'active' && (
								<AuthAlert alert={alert} />
							)}
							{children}
						</Box>
					</Section>
				</div>
			</div>
		</div>
  	);
}

AuthLayout.propTypes = {
  auth: PropTypes.object.isRequired,
  getAlert: PropTypes.func,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  alert: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  children: PropTypes.any,
}

const mapStateToProps = state => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  theme: state.theme,
  alert: state.auth.alert,
})

export default connect(mapStateToProps, { getAlert })(withRouter(withStyles(styles)(AuthLayout)))
